<div class="background-icon-collection-overflow-hidden">
  <app-background-icon
    src="/assets/images/icons/treats-pink.svg"
    [top]="20"
    [left]="15"
    [width]="175"
    [opacity]="0.5"
  />
  <app-background-icon
    src="/assets/images/icons/carry_crate-pink.svg"
    [top]="20"
    [left]="60"
    [width]="230"
    [opacity]="0.5"
  />
  <app-background-icon
    src="/assets/images/icons/cat-pink.svg"
    [top]="20"
    [left]="90"
    [width]="300"
    [opacity]="0.5"
  />
  <app-background-icon
    src="/assets/images/icons/kennel-pink.svg"
    [top]="60"
    [left]="5"
    [width]="140"
    [opacity]="0.5"
  />
  <app-background-icon
    src="/assets/images/icons/medicine-pink.svg"
    [top]="95"
    [left]="20"
    [width]="210"
    [opacity]="0.5"
  />
  <app-background-icon
    src="/assets/images/icons/paw-pink.svg"
    [top]="80"
    [left]="95"
    [width]="130"
    [opacity]="0.5"
  />
</div>